import React, { PropTypes } from 'react';
import { Button } from "antd";

export const ObservationComponent = ({ record, goObservationStudentsListPage, goObservationDetail, goDeleteObservationRecord, goEditObservationRecord, showCount}) => {
  const formatDate = (record_date) => {
    var date = new Date(record_date);
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? '0' + m : m;
    var d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    return y + '-' + m + '-' + d;
  }

  const getImage = (url) => {
    if(!url||url===""){
      return ""
    }
    if (url.indexOf('?imgeView2') >= 0 || url.indexOf('?imageMogr2') >= 0) {
      return url;
    }
    return url + '?imageView2/1/w/300';
  }

  const getStudentName = (students) => {
    return students.slice(0, 8).map(s => s.full_name).join(',') + (students.length > 8 ? `...（${students.length}人）` : `(${students.length}人）`)
  }

  return (
    <div className="observation-component" onClick={() => goObservationDetail(record)}>
      <div className="title">{record.segments_info[0].text}</div>
      <div className="time">{formatDate(record.record_date)}</div>
      {goEditObservationRecord?<div className="edit-btn" onClick={(event) => {
        event.stopPropagation(); // 阻止事件冒泡
        goEditObservationRecord(record)
      }}>
        编辑
      </div>:null}
      {goDeleteObservationRecord?<div className="delete-btn" onClick={(event) => {
        event.stopPropagation(); // 阻止事件冒泡
        goDeleteObservationRecord(record)
      }}>
        删除
      </div>:null}
      <div>
        <img src={getImage(record.segments_info[0].image_url)} alt="" className="img"/>
      </div>
      <div className="student-name">{getStudentName(record.students)}</div>
      <Button type="primary" size="large" onClick={(e) => goObservationStudentsListPage(e, record)}>
        {record.complete ? '修改评价' : (showCount ? '去评价（未评' + (record.students.length - record.complete_count) + '人）' : '去评价')}
      </Button>
    </div>
  )
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/development/commonComponent/ObservationComponent.jsx